import { BaseValidator } from './baseValidator';
import { ValidatorRule } from './validatorRule.constants';

export class PhoneNumberFieldValidator extends BaseValidator {
    constructor(rules: ValidatorRule[] = []) {
        super(rules);
    }
}
